var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"fieldset"},[_c('div',{staticClass:"form-row"},[_c('field-box',{attrs:{"name":"investment[investment_type]","label":_vm.$t('forms.investment_type'),"type":"select","options":_vm.investmentTypeOptions,"disabled":_vm.disabled,"has-error":_vm.errors?.['investment.investment_type']?.length}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }